import {REMOVE_STORE, STORE_LIST} from './actionTypes';
import {fetchJson} from '../util/fetch';

export const removeStore = id => {
  return dispatch => {
    dispatch({
      type: REMOVE_STORE,
      id
    });
  };
};

export const getStores = () => {
  return dispatch => {
    return fetchJson(dispatch, '/api/store')
      .then(resp => {
        if (resp.ok) {
          dispatch({
            type: STORE_LIST,
            stores: resp.json
          });
        }
      });
  };
};

export const createStore = (storeId, storeName) => dispatch => {
  return fetchJson(dispatch, '/api/store',
    {
      method: 'POST',
      body: JSON.stringify({
        id: storeId,
        name: storeName
      })
    })
    .then(resp => {
      if (resp.ok) {
        return dispatch(getStores());
      }
    });
};



// WEBPACK FOOTER //
// ./src/store/storesActions.js